module.exports = __webpack_public_path__ + "static/media/quiz3.e5f2aed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spring/quiz3.png
// module id = 156
// module chunks = 0